module.exports = __webpack_public_path__ + "static/media/settings.d5c5234b.svg";